var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Wireless keyboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#EEF2F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 112,
    height: 44,
    rx: 8,
    fill: "#002454"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#9e00ff",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 50,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#fff",
    opacity: 0.35
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 64,
    width: 84,
    height: 10,
    rx: 3,
    fill: "#9e00ff",
    opacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductKeyboard);
export default __webpack_public_path__ + "static/media/product-keyboard.eb252d5b40e777d177a317f7705afa52.svg";
export { ForwardRef as ReactComponent };